<div class="c-sidebar__selector c-sidebar__desktop">
  <p500-ui-applications-selector-desktop class="c-sidebar__application-desktop" [applications]="applications" [appsToShowLimit]="2">
  </p500-ui-applications-selector-desktop>
</div>
